const ANCHOR_PATTERN = /<a\b([^>]*)>([\s\S]*?)<\/a\s*>/gi;
const HREF_PATTERN = /\bhref\s*=\s*(?:"([^"]*)"|'([^']*)'|([^\s"'=<>`]+))/i;
const BLOCKED_ARTICLE_HOST = "app.thriveglobal.com";
/** Keep CMS link copy while removing links back into the legacy Thrive app. */
export function stripBlockedArticleLinks(html) {
    return html.replace(ANCHOR_PATTERN, (anchor, attributes, children) => {
        const hrefMatch = HREF_PATTERN.exec(attributes);
        const href = hrefMatch?.[1] ?? hrefMatch?.[2] ?? hrefMatch?.[3];
        return href && isBlockedArticleHref(href) ? children : anchor;
    });
}
function isBlockedArticleHref(href) {
    try {
        return new URL(href, "https://healthos.local").hostname.toLowerCase() === BLOCKED_ARTICLE_HOST;
    }
    catch {
        return false;
    }
}
//# sourceMappingURL=article-html.js.map